module.exports = __webpack_public_path__ + "img/hallstatt.10430681.jpg";